import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ComposeIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="m22.2 6.2-9.5 9.5a1 1 0 0 1-.46.27l-4 1a1 1 0 0 1-1.21-1.21l1-4a1 1 0 0 1 .26-.47l9.5-9.5a3.12 3.12 0 0 1 4.42 4.42Zm-3-3a1.12 1.12 0 0 1 1.6 1.6l-.8.79L18.41 4l.8-.8ZM17 5.42 18.59 7l-7.1 7.1-.78.2-1-1 .2-.79L17 5.41Z"
        clipRule="evenodd"
      />
      <path d="M4 3a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-7a1 1 0 1 0-2 0v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h7a1 1 0 1 0 0-2H4Z" />
    </Icon>
  )
);
export default ComposeIcon;
